import React from "react";
import BookingForm from "./BookingForm";
import BalanceReceipt from "./BalanceReceipt";
import DeliveryNote from "./DeliveryNote";
import FinalInvoice from "./FinalInvoice";
import Loader from "components/Loader";
import CompletedTxn from "./CompletedTxn";
import CancelledTxn from "./CancelledTxn";
import RTOStatus from "./RTOStatus";
import InsuranceStatus from "./InsuranceStatus";

const TransactionStageSelector = ({ data }) => {
  const [showLoader, setShowLoader] = React.useState(false);

  function setLoader(value) {
    setShowLoader(value);
  }
  if (showLoader) return <Loader />;

  if (data.transactionStatus === null || data.transactionStatus === undefined)
    return <div>Error</div>;

  if (data.transactionStatus === "INITIATED")
    return <BookingForm data={data} setLoader={setLoader} />;

  if (data.transactionStatus === "BOOKING_FORM_COMPLETED")
    return <BalanceReceipt data={data} setLoader={setLoader} />;

  if (data.transactionStatus === "BALANCE_RECEIPT_FORM_COMPLETED")
    return <DeliveryNote data={data} setLoader={setLoader} />;

  if (data.transactionStatus === "DELIVERY_NOTE_FORM_COMPLETED")
    return <FinalInvoice data={data} setLoader={setLoader} />;

  if (data.transactionStatus === "FINAL_INVOICE_COMPLETED") {
    return <RTOStatus />;
  }
  if (data.transactionStatus === "RTO_COMPLETED") {
    return <InsuranceStatus />;
  }

  if (data.transactionStatus === "COMPLETED") {
    return <CompletedTxn data={data} setLoader={setLoader} />;
  }

  if (data.transactionStatus === "CANCELLED") {
    return <CancelledTxn data={data} setLoader={setLoader} />;
  }

  return <div>Error</div>;
};

export default TransactionStageSelector;
